import { IDeleteInformacoesEntregaObraClienteUseCase } from "../../../presentation/useCases/delete/delete_informacoes_entrega_obra_cliente_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DeleteInformacoesEntregaObraClienteUseCase
 */

export class DeleteInformacoesEntregaObraClienteUseCase implements IDeleteInformacoesEntregaObraClienteUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(idInformacoesEntregaObraCliente: number): Promise<void> {
    await this.repository.deleteInformacoesEntregaObrasCliente(idInformacoesEntregaObraCliente);

  }
}
